// utils/log.js
import { fetchData }  from '../api/api';

export const sendLogToServer = async (type, message, data = null) => {
  const timestamp = new Date().toISOString();
  const logEntry = { timestamp, type, message };
  if (data) {
    logEntry.data = data;
  }

  try {
    // fetchData — это ваша утилита для HTTP-запросов
    await fetchData('/api/log', 'POST', {
      logs: [logEntry],
      userId: data?.userId || 'unknown',
      context: {
        dialogGroupId: data?.dialogGroupId || null,
        stepId: data?.stepId || null,
        platform: navigator.userAgent,
        module: data?.module || 'general',
        action: data?.action || 'log',
      },
    });
  } catch (error) {
	console.error('Ошибка отправки лога на сервер:', JSON.stringify(error, Object.getOwnPropertyNames(error)));
  }
};